import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/components/pepmuse/AuthContext";
import { Logo } from "@/components/pepmuse/Logo";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const match = location.hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];
    if (!sessionId) {
      setError("Missing sign-in session. Please try again.");
      return;
    }
    (async () => {
      try {
        const res = await fetch(`${API}/api/auth/google/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.detail || "Sign-in failed");
        setUser(data);
        navigate("/account", { replace: true });
      } catch {
        navigate("/account", {
          replace: true,
          state: { authError: "Google sign-in didn't complete. Please try again." },
        });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="flex min-h-screen flex-col items-center justify-center bg-ink px-6">
      <Logo />
      {error ? (
        <p role="alert" data-testid="auth-callback-error" className="mt-6 text-sm text-red-200">
          {error}
        </p>
      ) : (
        <p data-testid="auth-callback-status" className="mt-6 text-sm text-paper/55">
          Completing your sign-in…
        </p>
      )}
    </div>
  );
}
